/**
 * SkipLink — visually hidden until focused, lets keyboard users jump
 * straight to the main content. Bilingual label.
 */

import { useLanguage } from '@/hooks/useLanguage';

export function SkipLink(): JSX.Element {
  const { language } = useLanguage();
  return (
    <a
      href="#main-content"
      className="bg-medical-primary focus:ring-medical-primary sr-only z-[100] rounded-md px-4 py-2 text-sm font-medium text-white shadow-lg focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:ring-2 focus:ring-offset-2 focus:outline-none"
      data-testid="link-skip-to-content"
    >
      {language === 'ar' ? 'تخطَّ إلى المحتوى الرئيسي' : 'Skip to main content'}
    </a>
  );
}
